:host {
  display: inline-block;

  --z-icon-width: 16px;
  --z-icon-height: 16px;
  --z-icon-right-margin: 0;
}

:host([disabled]:not([disabled="false"])) {
  pointer-events: none;
}

:host .z-button--container {
  display: inline-flex;
  width: 100%;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  padding: 0;
  border-width: var(--border-size-medium);
  border-style: solid;
  border-radius: var(--border-radius);
  cursor: pointer;
  fill: currentcolor;
  font-family: var(--font-family-sans);
  font-size: 14px;
  font-weight: var(--font-sb);
  letter-spacing: 0.3px;
  line-height: 1;
  outline: none;
  text-decoration: none;
  text-transform: uppercase;
  white-space: nowrap;
}

:host .z-button--container:focus:focus-visible {
  box-shadow: var(--shadow-focus-primary);
}

:host .z-button--container.z-button--has-text {
  min-width: calc(var(--space-unit) * 8);
  padding: 0 calc(var(--space-unit) * 2);
}

:host .z-button--container.z-button--has-text z-icon {
  --z-icon-right-margin: var(--space-unit);
}

:host([size="big"]) .z-button--container {
  min-width: 44px;
  height: 44px;
}

:host([size="small"]) .z-button--container {
  min-width: 36px;
  height: 36px;
}

:host([size="x-small"]) .z-button--container {
  min-width: 32px;
  height: 32px;
}

:host([variant="primary"]) .z-button--container {
  border-color: var(--color-primary01);
  background-color: var(--color-primary01);
  color: var(--color-text-inverse);
}

@media (hover: hover) {
  :host([variant="primary"]) .z-button--container:hover {
    border-color: var(--color-hover-primary);
    background-color: var(--color-hover-primary);
    color: var(--color-text-inverse);
  }
}

:host([variant="primary"]) .z-button--container:active {
  border-color: var(--color-pressed-primary);
  background-color: var(--color-pressed-primary);
  box-shadow: var(--shadow-2);
  color: var(--color-text-inverse);
}

:host([variant="primary"][disabled]:not([disabled="false"])) .z-button--container {
  border-color: var(--color-disabled01);
  background-color: var(--color-disabled01);
  color: var(--color-disabled03);
}

:host([variant="secondary"]) .z-button--container {
  border-color: var(--color-primary01);
  background-color: var(--color-surface01);
  color: var(--color-primary01);
}

@media (hover: hover) {
  :host([variant="secondary"]) .z-button--container:hover {
    border-color: var(--color-hover-primary);
    background-color: var(--color-surface01);
    color: var(--color-hover-primary);
  }
}

:host([variant="secondary"]) .z-button--container:active {
  border-color: var(--color-pressed-primary);
  background-color: var(--color-surface01);
  box-shadow: var(--shadow-2);
  color: var(--color-pressed-primary);
}

:host([variant="secondary"][disabled]:not([disabled="false"])) .z-button--container {
  border-color: var(--color-disabled01);
  background-color: var(--color-surface01);
  color: var(--color-disabled03);
}

:host([variant="tertiary"]) .z-button--container {
  border-color: var(--color-primary02);
  background-color: var(--color-primary02);
  color: var(--color-primary01);
}

@media (hover: hover) {
  :host([variant="tertiary"]) .z-button--container:hover {
    border-color: var(--color-primary03);
    background-color: var(--color-primary03);
    color: var(--color-hover-primary);
  }
}

:host([variant="tertiary"]) .z-button--container:focus:focus-visible {
  border-color: var(--color-primary02);
  background-color: var(--color-primary02);
  color: var(--color-primary01);
}

:host([variant="tertiary"]) .z-button--container:active {
  border-color: var(--color-primary02);
  background-color: var(--color-primary02);
  box-shadow: var(--shadow-2);
  color: var(--color-primary01);
}

:host([variant="tertiary"][disabled]:not([disabled="false"])) .z-button--container {
  border-color: var(--color-disabled01);
  background-color: var(--color-disabled01);
  color: var(--color-disabled03);
}
